import script from "./AbsenceDaysCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AbsenceDaysCard.vue?vue&type=script&setup=true&lang=js"

import "./AbsenceDaysCard.vue?vue&type=style&index=0&id=17aed4c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17aed4c0"]])

export default __exports__